import { api } from './client';

export const fetchSettingsStatus = () =>
    api.get<{ hasKeys: boolean }>('/user/settings/status');

export const saveSettings = (apiKey: string, secretKey: string) =>
    api.post<{ message: string }>('/user/settings', { api_key: apiKey, secret_key: secretKey });
